<template>
  <ValidationProvider
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
    v-slot="{ errors }"
  >
    <v-autocomplete
      :class="`${customClass} ${requiredClassByRules()}`"
      :items="innerItems"
      v-model="innerValue"
      v-bind="$attrs"
      v-on="$listeners"
      :error-messages="errors"
      :item-text="dealers ? 'fullName' : 'name'"
      :item-value="itemValue"
      :return-object="returnObject"
      :search-input.sync="search"
      :loading="loading"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      :multiple="multiple"
    >
      <template
        v-if="multiple"
        v-slot:selection="{ index, item }"
      >
        <span
          v-if="index === 0"
          class="caption mr-2"
        >
          <template v-if="innerValue.length === 1">
            {{ dealers ? item.fullName : item.name }}
          </template>
          <template v-else-if="
            innerValue.length > 1 &&
            innerValue.length < 5"
          >
            Vybrány {{ innerValue.length }} položky
          </template>
          <template v-else-if="innerValue.length > 4">
            Vybráno {{ innerValue.length }} položek
          </template>
        </span>
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { mapActions } from 'vuex';
import { validationMixin } from '@/components/mixins/validation';

export default {
  name: 'SolverAutocomplete',
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
    vid: {
      type: String,
      default: '',
    },
    value: {
      type: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    returnObject: {
      type: Boolean,
      defaut: false,
      required: false,
    },
    itemValue: {
      type: String,
      defaut: 'id',
      required: false,
    },
    multiple: {
      type: Boolean,
      defaut: false,
      required: false,
    },
    dealers: {
      type: Boolean,
      defaut: false,
      required: false,
    },
  },
  data: () => ({
    innerValue: '',
    innerItems: [],
    search: '',
    loading: false,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    innerItems(newVal) {
      this.$emit('items', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
    items(newVal) {
      this.innerItems = newVal;
    },
    search(value) {
      this.searchUser(value);
    },
  },
  methods: {
    ...mapActions({
      searchDealers: 'users/searchDealers',
    }),
    searchUser(query) {
      this.loading = true;
      const searchParams = {
        admin: true,
      };
      if (this.cancel) {
        this.cancel();
        this.cancel = null;
      }
      searchParams.cancelHandler = (cancel) => {
        this.cancel = cancel;
      };
      if (this.dealers) {
        this.searchDealers({
          admin: true,
          includeAdministrators: true,
          searchTerm: query,
          options: {
            page: 1,
            sortBy: ['fullName'],
            sortDesc: [true],
          },
        })
          .then((response) => {
            this.innerItems = response.data.items;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.getUsers({
          roles: ['SOLVER'],
          searchTerm: query,
        })
          .then((response) => {
            this.innerItems = response.data.items;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
    if (this.items) {
      this.innerValue = this.items;
    }
    this.searchUser('');
  },
};
</script>
